import {
  Button,
  Layout,
  notification,
  Space
} from 'antd';
import { FormInstance, FormProps } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import moment from 'moment';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import AdminOtcApiService from '../../api/AdminOtcApiService';
import Routes from '../../consts/Routes';
import AdminOtcPenaltyDTO from '../../models/AdminOtcPenaltyDTO';
import DateUtil from '../../utils/DateUtil';
import HistoryUtil from '../../utils/HistoryUtil';
import CustomForm from '../shared/CustomForm';
import PenaltyForm from './PenaltyForm';

const { Content } = Layout;

interface OtcPenaltiesProps {
  id: string;
}

interface OtcPenaltiesState {
  otcPenalty: AdminOtcPenaltyDTO,
  id: string,
  loading: boolean,
  penaltyNoticeLoading: boolean,
}

class OtcPenalties extends React.Component<RouteComponentProps<OtcPenaltiesProps> & FormProps, OtcPenaltiesState> {
  private readonly formRef = React.createRef<FormInstance>();

  constructor(props: RouteComponentProps<OtcPenaltiesProps> & FormProps) {
    super(props);
    this.state = {
      id: props.match.params.id,
      otcPenalty: AdminOtcPenaltyDTO.create({ contributionId: props.match.params.id }),
      loading: true,
      penaltyNoticeLoading: false,
    };
  }

  componentDidMount() {
    this.getInitialValues();
  }

  render() {
    const { loading, otcPenalty, penaltyNoticeLoading } = this.state;

    return (
      <Content className="content-pad">
        <h3 className="ant-typography">OTC Penalties</h3>
        {loading ? undefined :
          <CustomForm name="Penalties" onFinish={this.submitForm} initialValues={otcPenalty} layout="vertical" formRef={this.formRef}>
            <PenaltyForm penaltyNoticeDate={otcPenalty.penaltyIssuedDate != null ? DateUtil.toTimeLocal(moment(otcPenalty.penaltyIssuedDate)) : ''}/>
            <Space>
              <Button type="primary" htmlType="submit">Save Penalty</Button>
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) =>
                  getFieldValue('penaltyPaidDate') === undefined || getFieldValue('penaltyPaidDate') === null ? (
                    <Button type="primary" loading={penaltyNoticeLoading}
                      onClick={() => this.sendLateNotice(this.formRef.current?.getFieldsValue())}>Save and Send Penalty Notice</Button>
                  ) : undefined}
              </FormItem>
              <Button onClick={this.cancelForm}>Cancel</Button>
            </Space>
          </CustomForm>
        }
      </Content>
    );
  }

  private submitForm = (values: any) => {
    AdminOtcApiService.saveOtcPenalty(this.state.id, { ...this.state.otcPenalty, ...values }, false)
      .then(() => {
        HistoryUtil.push(Routes.MANAGE_OTC);
        notification.success({ message: 'Penalty has been saved.' });
      })
      .catch(error => {
        notification.error({ message: error.message, description: error.description });
      });
  }

  private sendLateNotice = (values: any) => {
    this.setState({ penaltyNoticeLoading: true });
    AdminOtcApiService.saveOtcPenalty(this.state.id, { ...this.state.otcPenalty, ...values }, true)
      .then((result) => {
        if (result.succeeded) {
          HistoryUtil.push(Routes.MANAGE_OTC);
          notification.success({ message: 'Penalty notice sent successfully.' });
        }
        else {
          if (result.errors[0] != null) {
            notification.error({ message: result.errors[0] });
          }
          else {
            notification.error({ message: 'Failed to send penalty notice.' });
          }
        }
        this.setState({ penaltyNoticeLoading: false });
      })
      .catch(error => {
        notification.error({ message: error.message, description: error.description });
        this.setState({ penaltyNoticeLoading: false });
      });
  }

  private cancelForm = () => {
    HistoryUtil.push(Routes.MANAGE_OTC);
  }

  private getInitialValues = () => {
    AdminOtcApiService.getOtcPenalty(this.state.id).then(otcPenalty => {
      // Make date values moments so that the date pickers work properly
      if (otcPenalty.penaltyDueDate) {
        otcPenalty.penaltyDueDate = moment.utc(otcPenalty.penaltyDueDate);
      }

      if (otcPenalty.penaltyIssuedDate) {
        otcPenalty.penaltyIssuedDate = moment.utc(otcPenalty.penaltyIssuedDate);
      }

      if (otcPenalty.penaltyPaidDate) {
        otcPenalty.penaltyPaidDate = moment.utc(otcPenalty.penaltyPaidDate);
      }

      if (otcPenalty.waivedDate) {
        otcPenalty.waivedDate = moment.utc(otcPenalty.waivedDate);
      }

      this.setState({ otcPenalty, loading: false });
    }).catch(() => {
      this.setState({ loading: false });
    });
  }
}

export default OtcPenalties;